import { NgClass } from '@angular/common';
import { NgModule } from '@angular/core';

import { LogoComponent } from './logo.component';

/**
 * NgModule that exports the {@link LogoComponent} for use in application features.
 *
 * @remarks
 * This module declares and exports the {@link LogoComponent}, making it available
 * for import in feature modules throughout the application. It imports {@link NgClass}
 * for dynamic CSS class binding in the component's template.
 */
@NgModule({
  imports: [NgClass],
  declarations: [LogoComponent],
  exports: [LogoComponent],
})
export class LogoModule {}
